export default __webpack_public_path__ + "static/media/placeholder_illustration.f7ca1cfc.png";